import React from 'react';
import {GenericModal} from "../../common/genericModal/GenericModal";
import KeyboardWizard from "./KeyboardWizard";
import {keyboardWizardStore} from "../../../redux/keyboardWizard/keyboardWizardStore";
import {useAppSelector} from "../../../redux/hooks";

interface IKeyboardWizardModalProps {
  onStartPlaying: () => void;
}

export default function KeyboardWizardModal({onStartPlaying}: IKeyboardWizardModalProps) {
  const isOpen = useAppSelector(keyboardWizardStore.getIsOpen);

  return (
    <GenericModal
      canShow={() => { return isOpen; }}
      backgroundColor={"white"}
      maxWidth={`min(910px, 95%)`}
      padBody={false}
      showCloseButtonInBody={true}
      onClose={() => { keyboardWizardStore.setIsOpen(false); }}
    >
      <KeyboardWizard onStartPlaying={onStartPlaying} mode={"modal"}/>
    </GenericModal>
  );
}
